export default __webpack_public_path__ + "static/media/PriceTag.b9c3dabc.svg";